import './SecondaryControls.css'
import formatMessage from 'format-message'
import React from 'react'
import ColorButton from './ColorButton'

import TextSizeButton from './annotations/freetext/TextSizeButton'
import InkStrokeWidthButton from './annotations/InkStrokeWidthButton.js'
import {
  POINT_COLORS,
  AREA_COLORS,
  INK_COLORS,
  STRIKEOUT_COLORS,
  HIGHLIGHT_COLORS,
  ANNOTATION_TYPES,
  FREETEXT_COLORS,
  FREETEXT_BACKGROUND_COLORS,
  FONTS_BY_SIZE,
  INK_STROKE_WIDTH_OPTIONS,
} from './constants'

const colors = {
  point: POINT_COLORS,
  area: AREA_COLORS,
  ink: INK_COLORS,
  strikeout: STRIKEOUT_COLORS,
  highlight: HIGHLIGHT_COLORS,
  freetext: FREETEXT_COLORS,
}

const bgColors = {
  freetext: FREETEXT_BACKGROUND_COLORS,
}

export default function SecondaryControls({
  controlMode,
  currentBgColor,
  currentColor,
  currentFont,
  currentInkWidth = null,
  onCurrentBgColorChange,
  onCurrentColorChange,
  onCurrentInkStrokeWidthChange = () => {},
  onCurrentTextSizeChange,
}) {
  const isFreeText = controlMode === 'freetext'
  const isInk = controlMode === 'ink'
  const bgColorLabel = formatMessage('Background')
  const textSizeLabel = formatMessage('Size')
  const inkWidthLabel = formatMessage('Line')

  const colorButtons =
    colors[controlMode] &&
    Object.values(colors[controlMode]).map((colorValue) => {
      return (
        <ColorButton
          key={colorValue}
          colorValue={colorValue}
          isSelected={currentColor === colorValue}
          onCurrentColorChange={onCurrentColorChange}
          isBackground={false}
        />
      )
    })

  const bgColorButtons =
    bgColors[controlMode] &&
    Object.values(bgColors[controlMode]).map((colorValue) => {
      return (
        <ColorButton
          key={colorValue}
          colorValue={colorValue}
          isSelected={currentBgColor === colorValue}
          onCurrentColorChange={onCurrentBgColorChange}
          isBackground={true}
        />
      )
    })

  const textSizeButtons = Object.keys(FONTS_BY_SIZE).map((size) => {
    const font = FONTS_BY_SIZE[size]
    return (
      <TextSizeButton
        key={size}
        sizeValue={size}
        font={font}
        isSelected={font === currentFont}
        onCurrentTextSizeChange={onCurrentTextSizeChange}
      />
    )
  })

  const inkWidthButtons = Object.keys(INK_STROKE_WIDTH_OPTIONS).map((option) => {
    const width = INK_STROKE_WIDTH_OPTIONS[option]
    return (
      <InkStrokeWidthButton
        key={option}
        sizeValue={option}
        width={width}
        isSelected={width === currentInkWidth}
        onCurrentInkStrokeWidthChange={onCurrentInkStrokeWidthChange}
      />
    )
  })

  return (
    ANNOTATION_TYPES.includes(controlMode) &&
    colorButtons &&
    colorButtons.length && (
      <div className="SecondaryControls" tabIndex={-1}>
        <div className="SecondaryControls-buttons">{colorButtons}</div>
        {isFreeText && (
          <div className="SecondaryControls-annotation">
            <div className="SecondaryControls-label">{bgColorLabel}</div>
            <div className="SecondaryControls-buttons">{bgColorButtons}</div>
            <div className="SecondaryControls-label">{textSizeLabel}</div>
            <div className="SecondaryControls-buttons" style={{ display: 'flex' }}>
              {textSizeButtons}
            </div>
          </div>
        )}
        {isInk && (
          <div className="SecondaryControls-annotation">
            <div className="SecondaryControls-label">{inkWidthLabel}</div>
            <div className="SecondaryControls-buttons" style={{ display: 'flex' }}>
              {inkWidthButtons}
            </div>
          </div>
        )}
      </div>
    )
  )
}
